module.exports = __webpack_public_path__ + "static/media/photo_profile_2.68c0b9c7.webp";